import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "./constant";

const useApiReq = async ({
  method,
  url,
  data = null,
  params = null,
  headers = { accept: "application/json" },
  onCancel,
}) => {
  if (!url) throw new Error("URL is required.");
  if (!method) throw new Error("Method is required.");
  if (
    !["GET", "POST", "PUT", "PATCH", "DELETE"].includes(method.toUpperCase())
  ) {
    throw new Error("Invalid HTTP method.");
  }

  if (
    params &&
    typeof params === "object" &&
    method === "GET" &&
    params &&
    Object.keys(params).length > 0
  ) {
    url += "?";
    Object.keys(params).forEach((key, index) => {
      url += `${key}=${params[key]}${
        index < Object.keys(params).length - 1 ? "&" : ""
      }`;
    });
  }

  const source = axios.CancelToken.source(); // Create a cancel token

  if (onCancel) {
    onCancel(source); // Pass the full cancel source
  }

  try {
    const res = await axios({
      method: method.toUpperCase(),
      url: `${API_URL}${url}`,
      ...(method !== "GET" && { data }),

      headers,
      cancelToken: source.token,
    });
    return { response: res.data, error: null };
  } catch (err) {
    if (axios.isCancel(err)) {
      return { response: null, error: "Request was cancelled." };
    } else {
      return { response: null, error: err.response.data };
    }
  }
};

export default useApiReq;
